var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Ticketssvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.556 5.333h8.888v5.334H3.556V5.333zM14.666 8c0 .736.598 1.333 1.334 1.333V12c0 .736-.597 1.333-1.333 1.333H1.333A1.333 1.333 0 010 12V9.333a1.333 1.333 0 100-2.666V4c0-.736.597-1.333 1.333-1.333h13.334C15.403 2.667 16 3.264 16 4v2.667c-.736 0-1.333.597-1.333 1.333zm-1.333-2.889a.667.667 0 00-.666-.667H3.333a.667.667 0 00-.666.667v5.778c0 .368.298.667.666.667h9.334a.667.667 0 00.666-.667V5.11z",
    fill: "#9FA2B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Ticketssvg);
export default __webpack_public_path__ + "static/media/_2Ticketssvg.73cd435084e6b1ab39a882e996acbe70.svg";
export { ForwardRef as ReactComponent };